<div class="tab-pane" role="tabpanel" id="Constructores">
    <fieldset id="agregar_constructores" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n de los Constructores</strong></h3>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar Constructor</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="rut_pro" class="col-md-1" style="padding-top: 15px">RUT</label>
                            <div class="col-md-2">
                                <form [formGroup]="rut_const">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" id="rut_const" name="rut_const" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_const && rut_const.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>

                                    </mat-form-field>
                                </form>
                            </div>
                            <div class="col-md-2">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_const" [disabled]="!rut_const.valid" (click)="get_Constructores(rut_const.controls.rut.value)">
                                        Agregar Constructores
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div></div>

                    <!--Detalle de los constructoress-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span> {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_Constructores(row.rut,rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_Constructores(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
    <!-- Modal -->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de los constructores</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del Constructor</strong>, su solicitud pasar&aacute; por un proceso de verificaci&oacute;n del constructor ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md" [(ngModel)]="constructores.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_const">Nombre(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="nombre_const" name="nombre_const" type="text" placeholder="Nombre" [(ngModel)]="constructores.nombre" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div id="hide-prop-enterprise">
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apelpat_const">Apellido Paterno(<span style="color: red">*</span>)</label>
                        <div class="col-md-6">
                            <input id="apelpat_const" name="apelpat_const" type="text" placeholder="Apellido Paterno" [(ngModel)]="constructores.apellido_pat" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apelmat_const">Apellido Materno</label>
                        <div class="col-md-6">
                            <input id="apelmat_const" name="apelmat_const" type="text" placeholder="Apellido Materno" [(ngModel)]="constructores.apellido_mat" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div hidden="hidden">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_calle_const">Direcci&oacute;n: Calle</label>
                        <div class="col-md-3">
                            <input id="dir_calle_const" name="dir_calle_const" type="text" placeholder="Calle" [(ngModel)]="constructores.direccion" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="dir_num_const">Direcci&oacute;n: Numero</label>
                        <div class="col-md-3">
                            <input id="dir_num_const" name="dir_num_const" type="text" placeholder="Numero" [(ngModel)]="constructores.direccion_num" class="form-control input-md">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_comp_const">Direcci&oacute;n: Complemento</label>
                        <div class="col-md-3">
                            <input id="dir_comp_const" name="dir_comp_const" type="text" placeholder="Complemento" [(ngModel)]="constructores.direccion_complemento" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="comuna_const">Comuna(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="comuna_const" name="comuna_const" type="text" placeholder="Comuna" [(ngModel)]="constructores.comuna" class="form-control input-md">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_completa_const">Direcci&oacute;n: Completa</label>
                        <div class="col-md-3">
                            <input id="dir_completa_const" name="dir_completa_const" type="text" placeholder="Complemento" [(ngModel)]="constructores.direccion_completa" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="comuna_const"></label>
                        <div class="col-md-3">

                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_const">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono_const" name="fono_const" type="text" placeholder="Tel&eacute;fono" [(ngModel)]="constructores.fono" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_const">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_const" name="email_const" type="email" placeholder="mail@ejemplo.com" [(ngModel)]="constructores.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_const" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_const" (click)="saveConstructores()" [disabled]="!constructores.rut || !constructores.nombre || !constructores.direccion || !constructores.direccion_num || !constructores.comuna || !constructores.mail || !constructores.apellido_pat">Ingresar constructor  <i class="fa fa-user-o" aria-hidden="true"></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material dialog modal-->
</div>